import React, { Component } from 'react';
import './CaseStudy.css';

class CaseStudy extends Component {
  render() {
    return (
      <div className="box">
        <div className="case-study" id="image">
          <img
            src={this.props.image}
            className="img-responsive"
            alt="Responsive"
          />
        </div>
        <div className="overlay">
          <div className="content">
            <h3> {this.props.overlay.heading} </h3>
            <p>{this.props.overlay.text}</p>
          </div>
        </div>
      </div>
    );
  }
}

export default CaseStudy;



// WEBPACK FOOTER //
// ./src/components/common/CaseStudy.js